import _ from 'underscore';

export class VideoSyncer {
  constructor(videoRepository) {
    this.videoRepository = videoRepository;
    this.syncIntervalMS = 5000;
    this.running = false;
  }

  startSync({
    idString,
    shouldStop,
    onUpdate = _.noop,
    onError = _.noop,
    activityLogger,
    perfMarker,
  }) {
    this.running = true;
    const processingPerfMarker = perfMarker && perfMarker.createChild('ProcessingVideo');
    if (processingPerfMarker) {
      processingPerfMarker.willInit();
    }
    this.syncTask({
      idString,
      shouldStop,
      onUpdate,
      onError,
      processingPerfMarker,
      activityLogger,
    });
  }

  syncTask({
    idString,
    shouldStop,
    onUpdate = _.noop,
    onError = _.noop,
    previousStatus = undefined,
    processingPerfMarker = null,
    activityLogger = null,
  }) {
    /* istanbul ignore if */
    if (!this.running) {
      return;
    }
    this.videoRepository.getVideo({ id: idString })
      .then((video) => {
        // We should not run callback if sync is stopped.
        /* istanbul ignore if */
        if (!this.running) {
          return;
        }

        if (activityLogger) {
          activityLogger.signal(`ProcessingVideo - ${idString}`);
        }
        // We do this check here because we need to make 1 request
        // for that caller component can update at least once which makes sure
        // we can access to newest video list props in `shouldStop`.
        if (shouldStop()) {
          /* istanbul ignore next */
          return;
        }
        /* istanbul ignore else */
        if (previousStatus !== video.Status) {
          onUpdate(video);
        }

        if (video.Status === 'Active') {
          if (activityLogger && processingPerfMarker) {
            activityLogger.signal(`ProcessingComplete - ${idString}`);
            processingPerfMarker.done();
          }
        }

        if (video.Status === 'Failed') {
          /* istanbul ignore if */
          if (activityLogger && processingPerfMarker) {
            activityLogger.signal(`ProcessingFailed - ${idString}`);
            processingPerfMarker.done();
          }
        }
        if (video.Status && video.Status !== 'Active' && video.Status !== 'Failed') {
          setTimeout(() => this.syncTask({
            idString,
            shouldStop,
            onUpdate,
            previousStatus: video.Status,
            processingPerfMarker,
            activityLogger,
          }), this.syncIntervalMS);
        }
      })
      .catch(onError);
  }

  stopAll() {
    this.running = false;
  }
}
